import styled from 'styled-components';

export const IconTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
    gap: 5px;
    margin-bottom: 15px;
`;

export const Icon = styled.img`
  width: 20px;
  height: 20px;
`;

export const TitleWrapper = styled.span`
  font-size: 16px;
  line-height: 1.2;
  font-weight: 400;
  color: #1C1C1C;
`;

export const Title = styled.h3`
  font-size: 18px;
  line-height: 1.5;
  margin-bottom:15px;
  font-weight: 500;
  color: #323131;
`;

export const Badge = styled.span`
  margin-left: auto;
  background-color: #F4F4F5;
  padding: 4px 12px;
  border-radius: 5px;
  font-size: 12px;
  line-height: 1.2;
  font-weight: 700;
  color: #000000;
`;
